<template lang="pug">
.how.container
  .how__title
      span(v-html="tr.how.title")
  .how__subtitle
        span(v-html="tr.how.subtitle")
  .how__content
      .how__column
          .how__columnTitle(v-html="tr.how.columnTitle_1")
          .how__cliens-wp
              .how__clients
                  each val in [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8]
                      if val !==0.5
                          .how__clientNobody.wow.fadeIn(data-wow-duration=`2s`, data-wow-delay=`${val}s`)
                              img.how__clientsImg(src=`../../../assets/images/nobody.png`, alt="", )
                      else
                          .how__wrap.how_icon2.wow.fadeIn(data-wow-duration=`2s`, data-wow-delay=`${val}s`)
                              .how__clientNobody.wow.howFadeIn(data-wow-duration=`2s`, data-wow-delay=`1s`)
                                  img.how__clientsImg(src=`../../../assets/images/how_iconWhite.png`, alt="",)
                      if val !==0.4 && val !==0.8
                          .how__clientsPlus.wow.fadeIn(data-wow-duration=`2s`, data-wow-delay=`${val}s`) +
              a.how__btn.btn.btn_size_xs.btn_color(href="inside-partners") {{tr.how.btn}}

          .how__dsc
              span(v-html="tr.how.dsc_1")
          .how__wrap
              .how__additional
                  span(v-html="tr.how.additional_1")

      .main-content__border
      .how__column
          .how__columnTitle(v-html="tr.how.columnTitle_2")
          .how__partners
              PartnerNetwork
          //- img.how__partners-mobile(src=`../../../assets/images/how_person.png`, alt="")
          .how__dsc
              span(v-html="tr.how.dsc_2")
          .how__additional
              span(v-html="tr.how.additional_2")
      .main-content__border
      .how__column
          .how__columnTitle(v-html="tr.how.columnTitle_3")
          .how__shops(v-if="!englishVersion && !mexicoVersion")
            each val in [1, 2, 3, 4, 5, 6]
              img.how__shop.wow.fadeIn(
                src=`../../../assets/images/how_shop_${val}.png`
                alt=""
                data-wow-duration=`2s`
                data-wow-delay=`${val * 0.1}s`
                )
          .how__shops(v-if="englishVersion || mexicoVersion")
            each val in [1, 2, 3, 4, 5, 6]
              img.how__shop.wow.fadeIn(
                src=`../../../assets/images/how_shop_${val}_en.png`
                alt=""
                data-wow-duration=`2s`
                data-wow-delay=`${val * 0.1}s`
              )

          .how__dsc
              span(v-html="tr.how.dsc_3")
          .how__additional
              span(v-html="tr.how.additional_3")
  .main-content__border_dsc
</template>

<script>
import PartnerNetwork from '../PartnerNetwork'
import langOps from '@/mixins/langOps'

export default {
  components: {
    PartnerNetwork
  },
  data () {
    return {
      section: 'main'
    }
  },
  mixin: [langOps]
}
</script>

<style lang="scss">
  @import './style.scss';
</style>
